module.exports = __webpack_public_path__ + "static/media/iconPaso4.3e5c7fc8.svg";